import React from 'react';
import CorpsSection from '../components/CorpsSection';
import SkillList from '../components/SkillList';

const Awards = (props) => {
    return (
        <CorpsSection id="awards" title={props.data.titleBloc}>
            <SkillList texts={props.data.body} />

        </CorpsSection>
    );
};

export default Awards;